import React from 'react';
import DeleteBtn from './DeleteBtn';
import EditBtn from './EditBtn';
import Star from './Star';

const BookCard = ({ book }) => {
  const { name, author, thumbnail, price, rating, featured, id } = book;

  const allStar = Array(rating).fill('');

  return (
    <div className="book-card">
      <img
        className="h-[240px] w-[170px] object-cover lws-bookThumbnail"
        src={thumbnail}
        alt="book"
      />
      <div className="flex-1 h-full pr-2 pt-2 flex flex-col">
        <div className="flex items-center justify-between">
          <span className={`${featured && 'badge-success'} lws-Badge`}>
            {featured && 'featured'}
          </span>

          <div className="text-gray-500 space-x-2">
            <EditBtn id={id} />
            <DeleteBtn id={id} />
          </div>
        </div>

        <div className="space-y-2 mt-4 h-full">
          <h4 className="lws-bookName">{name}</h4>
          <p className="lws-author">{author}</p>
          <div className="lws-stars">
            {allStar.map((_, idx) => (
              <Star key={idx} />
            ))}
          </div>
          <p className="lws-price">BDT {price}</p>
        </div>
      </div>
    </div>
  );
};

export default BookCard;
